import React from 'react';

import ProjectDesktopImage from '../../../../components/project/project-desktop-image';
import ProjectSliderAnimation from '../../../../components/project/project-slider/project-slider-animation';
import ProjectQuote from '../../../../components/project/project-quote';
import ProjectVideoAds from '../../../../components/project/project-video-ads';

const LGCaseStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectDesktopImage
        desktopImage={acf.desktop_design}
        backgroundColor={acf.desktop_image_background}
        blurb={acf.desktop_design_blurb}
        wrapperPadding={'3rem'}
      />
      <ProjectSliderAnimation
        slides={acf.slider}
        blurb={acf.slider_blurb}
        wrapperPadding={[
          'calc(10vw - 14px) 10vw 10vw 10vw',
          'calc(10vw - 14px) 0 10vw 0',
        ]}
      />
      <ProjectVideoAds
        ads={acf.video_ads}
        blurb={acf.video_ads_blurb}
        wrapperPadding={'0 0 10vw 0'}
      />
    </React.Fragment>
  );
};

export default LGCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/lg/index.js